<section aria-label="Preview FlyMSG">
  <button type="button" aria-label="Close preview" (click)="done()">×</button>
  <h2>Preview FlyMSG</h2>
  <p><strong>Category</strong> {{ data.shortcut.category_name || 'Imported' }}</p>
  <p><strong>FlyCut</strong> {{ data.shortcut.shortcut }}</p>
  <p><strong>Title/Description</strong> {{ data.shortcut.title }}</p>
  <div [innerHTML]="data.shortcut.html"></div>
  <button vng-button variant="primary" type="button" (click)="done()">Done</button>
</section>
